import {useCallback} from 'react';
import {Concept} from 'types';
import type {ViewMode} from 'services/advancedSearch/types';
import {useSetAdvancedSearchViewMode} from 'services/advancedSearchViewMode';
import {selectAdvancedSearchViewMode} from 'services/advancedSearchViewMode/reducer';
import {useAppSelector} from 'store/hooks';
import type {CurrentColumnsType, ViewModeType} from '../types';

export const useViewMode = ({
  currentColumns,
  addCurrentColumn,
}: Pick<
  CurrentColumnsType,
  'currentColumns' | 'addCurrentColumn'
>): ViewModeType => {
  const viewMode = useAppSelector(selectAdvancedSearchViewMode);
  const setViewMode = useSetAdvancedSearchViewMode();
  const handleViewModeChange = useCallback(
    (viewMode: ViewMode) => {
      if (viewMode === Concept.work) {
        if (!currentColumns.includes('workId')) {
          addCurrentColumn('workId');
        }
      }

      if (viewMode === Concept.manifestation) {
        if (!currentColumns.includes('ean')) {
          addCurrentColumn('ean');
        }
      }

      setViewMode(viewMode);
    },
    [currentColumns, addCurrentColumn, setViewMode],
  );

  return {
    viewMode,
    setViewMode: handleViewModeChange,
  };
};
